/*
 * @Author: xiashui 
 * @Date: 2020-08-27 18:08:34 
 * @Last Modified by: xiashui
 * @Last Modified time: 2020-09-08 14:47:22
 */

import Enum from './enum';
import { getTime, getRoute, getStorage, setStorage } from './utils';
import { write2Storage, getActionTpl } from '../trackUtils';

// 定义埋点存储在localStorage的key
const KEY = 'JSZXSTAT';
const options = feConfig.trackPoint;

function stat(el, binding) {
    elAddEvent(el, binding);
};

function elAddEvent(el, binding) {
    el.addEventListener('click', () => {
        dataLine(binding.value);
    });
};

function dataLine(value) {
    const { lineId, pointType } = value;
    if (!lineId || !pointType) { return; }
    const cacheData = JSON.parse(getStorage(KEY));
    // 判断是否有储存对象，有则存储数据，否则创建存储对象
    cacheData
    ? cacheData[lineId]
    ? setData(value)
    : setAttribute(lineId, value)
    : setKey(value);
};

// 存储数据，到此说明有对应数据
function setData(value) {
    const { lineId, pointType } = value;
    let cacheData = JSON.parse(getStorage(KEY));
    // 判断埋点类型
    switch (Enum.PointType[pointType]) {
        case 'start':
            // 如果是 start，加入起点信息
            Object.assign(cacheData[lineId], { startTime: getTime(), startRoute: getRoute() }, value);
        break;
        case 'end':
            // 如果有 start 且是 end，加入终点信息
            if (cacheData[lineId]['startTime']) {
                Object.assign(cacheData[lineId], { endTime: getTime(), endRoute: getRoute() }, value);
                // 到这里说明起点和终点信息收集完毕，需要添加到埋点
                addTrackInfo(cacheData[lineId]);
                // 添加到埋点后删除此条记录，完成一次路径统计
                delete cacheData[lineId];
            }
        break;
    }
    setStorage(KEY, JSON.stringify(cacheData));
};

// 添加到埋点数据
function addTrackInfo(data) {
    const { user, subject, period } = window;
    const dataPoint = getActionTpl();
    Object.assign(data, { teacherId: user, subject, period }); // 附加公共数据
    dataPoint.deviceCarrier = JSON.stringify(data);
    write2Storage(options.sKey, dataPoint);
};

// 创建存储对象，存储数据
function setKey(value) {
    setStorage(KEY, JSON.stringify({}));
    dataLine(value);
};

// 创建存储属性，存储数据
function setAttribute(lineId, value) {
    let cacheData = JSON.parse(getStorage(KEY));
    cacheData[lineId] = {};
    setStorage(KEY, JSON.stringify(cacheData));
    dataLine(value);
};

// 绑定到window对象，全局手动调用
window.lineTrack = dataLine;

export default stat;



// WEBPACK FOOTER //
// ./src/assets/plugin/track/pathStat/index.js